import styled from "@emotion/styled";
import dayjs from "dayjs";
import { Fragment, useMemo, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { IContactBy, IContactInteractionBy } from "../../../api/Contacts";
import { FilterCounterAtom } from "../../../atoms/ContactFilterAtoms";
import { ContactFiltersAtom } from "../../../atoms/ContactFiltersAtom";
import { notSelect } from "../../../utils/HelperStyles";
import DateRange from "../../Modal/container/DateRange";
import { useModal } from "../../Modal/Modal";
import { StyledRadio } from "../../StyledRadio";

const ItemDiv = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0px;
  cursor: pointer;
  ${notSelect}

  .interaction-date {
    margin: 0px 15px;

    font-size: 14px;
    line-height: 16px;
    color: #868482;
    font-weight: 600;
  }
`;

export const FilterName = styled.div`
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;

  line-height: 18px;
  margin: 10px 0px;
`;

const INTERACTION_DATE_TYPE = [
  { name: "Last day", type: IContactInteractionBy.LAST_DAY },
  { name: "Last week", type: IContactInteractionBy.LAST_WEEK },
  { name: "Last month", type: IContactInteractionBy.LAST_MONTH },
];

const INTERACTION_BY = [
  {
    name: "Opened",
    type: IContactBy.OPEN,
  },
  {
    name: "Clicked",
    type: IContactBy.CLICK,
  },
];

export default function FilterByInteraction() {
  const setFilterCounter = useSetRecoilState(FilterCounterAtom);
  const [contactFilters, setContactFilters] =
    useRecoilState(ContactFiltersAtom);
  const modal = useModal();
  const [interaction, setInteraction] = useState<IContactBy | null>(
    contactFilters.interaction || null
  );

  function handleDateRange() {
    modal.pushModal(
      <DateRange
        handleSave={(from, to) => {
          setContactFilters((f) => ({
            ...f,
            interactionDateRange: {
              from,
              to,
              type: IContactInteractionBy.DATE_RANGE,
            },
            interaction: interaction,
          }));

          setFilterCounter((c) => ({
            ...c,
            byInteractionCount: 1,
          }));
        }}
      />,
      "Filter by Date Range"
    );
  }

  function handleFilterBy(interactionDateType: string) {
    let interactionDateRange = null;

    switch (interactionDateType) {
      case IContactInteractionBy.LAST_DAY:
        interactionDateRange = {
          type: IContactInteractionBy.LAST_DAY,
          from: dayjs().subtract(1, "day").toDate(),
          to: dayjs().toDate(),
        };
        break;
      case IContactInteractionBy.LAST_WEEK:
        interactionDateRange = {
          type: IContactInteractionBy.LAST_WEEK,
          from: dayjs().subtract(1, "week").toDate(),
          to: dayjs().toDate(),
        };
        break;
      case IContactInteractionBy.LAST_MONTH:
        interactionDateRange = {
          type: IContactInteractionBy.LAST_MONTH,
          from: dayjs().subtract(1, "month").toDate(),
          to: dayjs().toDate(),
        };
        break;
    }

    setContactFilters((f) => ({
      ...f,
      interaction: interaction,
      interactionDateRange: interactionDateRange,
    }));

    setFilterCounter((c) => ({
      ...c,
      byInteractionCount: 1,
    }));
  }

  const isDateRange = useMemo(() => {
    return (
      contactFilters.interactionDateRange?.type ===
      IContactInteractionBy.DATE_RANGE
    );
  }, [contactFilters.interactionDateRange?.type]);

  return (
    <Fragment>
      {INTERACTION_BY.map((elem) => (
        <ItemDiv onClick={() => setInteraction(elem.type)}>
          <StyledRadio check={interaction === elem.type} />
          <FilterName>{elem.name}</FilterName>
        </ItemDiv>
      ))}

      {interaction && (
        <Fragment>
          <Label style={{ marginTop: "15px" }}>
            Choose the date of the latest interaction
          </Label>
          {INTERACTION_DATE_TYPE.map((elem) => (
            <ItemDiv onClick={() => handleFilterBy(elem.type)}>
              <StyledRadio
                check={contactFilters?.interactionDateRange?.type === elem.type}
              />
              <FilterName>{elem.name}</FilterName>
            </ItemDiv>
          ))}

          <ItemDiv onClick={() => handleDateRange()}>
            <StyledRadio check={isDateRange} />
            <FilterName>Date range</FilterName>

            {isDateRange && (
              <span className="interaction-date">
                {`${dayjs(contactFilters.interactionDateRange?.from).format(
                  "MM/D/YYYY"
                )} - ${dayjs(contactFilters.interactionDateRange.to).format(
                  "MM/D/YYYY"
                )}`}
              </span>
            )}
          </ItemDiv>
        </Fragment>
      )}
    </Fragment>
  );
}
